import { render, staticRenderFns } from "./OrderVerify.vue?vue&type=template&id=1a416bc3&"
import script from "./OrderVerify.vue?vue&type=script&lang=js&"
export * from "./OrderVerify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports